
import Vue from 'vue'
import * as Sentry from '@sentry/vue'
import axios from 'axios'
import { Prop, Component, Watch } from 'vue-property-decorator'
import { DistributorRelationship, DistributorUser } from '../../global/models'
import SplitSlider from './SplitSlider.vue'
import { consumeError } from '@/domains/global/utils'

@Component({
  components: { SplitSlider }
})
export default class UserForm extends Vue {
  @Prop({ type: Object, default: () => ({}) })
  value!: Partial<DistributorRelationship>

  @Prop({ type: Boolean, default: false })
  private readonly edit!: boolean

  distributors: DistributorUser[] = []

  get requiredRule() {
    return (value: string) => !!value || 'Field is required'
  }

  get formattedDistributors() {
    return this.distributors.map(distributor => ({
      ...distributor,
      displayName: `${distributor.givenName} ${distributor.surname}`
    }))
  }

  get selectedDistributorId() {
    return this.value.distributorId
  }

  set selectedDistributorId(newValue) {
    this.$emit('input', { ...this.value, distributorId: newValue })
  }

  @Watch('value', { immediate: true })
  public valueChanged(val: DistributorRelationship) {
    this.$emit('input', val)
  }

  mounted() {
    this.fetchDistributors()
  }

  async fetchDistributors() {
    try {
      const results = await axios.get<any>(`/distributors/all`)
      this.distributors = results.data
    } catch (error: any) {
      const formattedError = consumeError(error)
      if (formattedError.code !== 'SENTRY') {
        await this.$store.dispatch('error', formattedError.message)
      } else {
        Sentry.captureException(error)
      }
    }
  }
}
